import type { Project, ProjectListItem } from "./types";

const API_BASE = "/api/projects";

/** Fetch project list from remote */
export async function listProjects(): Promise<ProjectListItem[]> {
  const res = await fetch(API_BASE, { credentials: "include" });
  if (!res.ok) return [];
  return res.json();
}

/** Fetch a full project from remote */
export async function getProject(id: string): Promise<Project | null> {
  const res = await fetch(`${API_BASE}/${id}`, { credentials: "include" });
  if (!res.ok) return null;
  return res.json();
}

/** Save project to remote (upsert) */
export async function saveProject(project: Project): Promise<void> {
  const { id, ...data } = project;
  await fetch(`${API_BASE}/${id}`, {
    method: "PUT",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
}

/** Delete project from remote */
export async function deleteProject(id: string): Promise<void> {
  await fetch(`${API_BASE}/${id}`, {
    method: "DELETE",
    credentials: "include",
  });
}

/** Update project title */
export async function updateProjectTitle(
  id: string,
  title: string,
): Promise<{ id: string; title: string; updatedAt: number } | null> {
  const res = await fetch(`${API_BASE}/${id}`, {
    method: "PATCH",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ title }),
  });
  if (!res.ok) return null;
  return res.json();
}
